export default "__VITE_ASSET__D9rwD00Q__"